module.exports = __webpack_public_path__ + "static/media/sink-the-dictatorships-1.34c1c50d.png";